import type { ElementType, PropsWithChildren } from 'react';

import type { BreakpointsKeys } from '@/theme/types';

import * as S from './Visibility.styles';

export type Hidden = { [key in `${BreakpointsKeys}Hidden`]?: boolean };
export type Visible = { [key in `${BreakpointsKeys}Visible`]?: boolean };

export interface VisibilityProps extends Hidden, Visible, PropsWithChildren {
  as?: ElementType;
  handleDisplay?: boolean;
  handleVisibility?: boolean;
}

export const Visibility = ({
  as = 'div',
  children,
  handleDisplay = true,
  handleVisibility = true,
  ...rest
}: VisibilityProps) => {
  return (
    <S.Wrapper
      as={as}
      {...rest}
      handleDisplay={handleDisplay}
      handleVisibility={handleVisibility}
    >
      {children}
    </S.Wrapper>
  );
};

Visibility.displayName = 'Visibility';
